import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { notification, Tooltip } from "antd";
import AccountingTab from "./accountingTab";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TooltipTabWithholding from "./tooltipTabWithholding";
import DeleteModal from "../deleteModal";

const AccountBlock = ({
  data, goToDetail, index, selectedDocuments, setSelectedDocuments,
  allDocumentsSelected, setAllDocumentsSelected
}) => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [spinnerDelete, setSpinnerDelete] = useState(false);

  useEffect(() => {
    notification.destroy();
  }, []);

  const renderTooltipText = () => {
    return (
      <span className="description">{data?.deferredInvoiceDescription}</span>
    );
  };

  const renderTooltipTab = () => {
    return (
      <TooltipTabWithholding data={data} />
    );
  };

  return (
    <div className="precog-account-block-container">
      <div className="row" style={{ justifyContent: "flex-start" }}>
        {data.reasonId !== "GD" && <div className="internal-block" style={{ width: "auto" }}>
          <b className="title"> <FormattedMessage id="preCog.accountingTab.sectional" /></b>
          <p className="description" style={{ margin: "-1px 0 0 5px" }}>{`${data?.sectional ? data.sectional : "non definito"}`} {data?.regime ? `(${data?.regime})` : ""}</p>
        </div>}
        {data.reasonId !== "GD" && <div className="internal-block" style={{ marginLeft: "50px", width: "auto" }}>
          <b className="title"><FormattedMessage id="preCog.accountingTab.reason" /></b>
          <p className="description" style={{ margin: "-1px 0 0 5px" }}>{data?.reason}</p>
          {data?.deferredData?.length > 0 &&
            <Tooltip
              placement="topLeft" title={renderTooltipTab()} color={"white"} overlayClassName="precog-withholding-tooltip-container">
              <FontAwesomeIcon
                icon={["fas", "info-circle"]}
                style={{ color: "#0090d1", margin: "2px 0 0 10px", cursor: "pointer" }}
              />
            </Tooltip>
          }
        </div>}
      </div>
      <div className="row">
        {data.reasonId !== "GD" && <AccountingTab data={data} />}
      </div>
      <div className="row">
        <div className="internal-block">
          {(data?.fixedAsset && data.reasonId !== "GD")  &&
            <div className="text-container">
              <b className="title"><FormattedMessage id="preCog.accountingTab.fixedAsset" /></b>
              <FontAwesomeIcon
                icon={["fas", "check-circle"]}
                style={{ margin: "2px 0 0 10px", color: "#00aa00" }}
              />
            </div>
          }
          {(data.reasonId !== "GD" && data?.deferredInvoice) &&
            <div className="text-container">
              <b className="title"><FormattedMessage id="preCog.accountingTab.deferredInvoice" /></b>
              <Tooltip placement="top" title={renderTooltipText()} color={"white"} overlayClassName="precog-deferred-invoice-tooltip-container">
                <FontAwesomeIcon
                  icon={["fas", "info-circle"]}
                  style={{ color: "#0090d1", margin: "2px 0 0 10px", cursor: "pointer" }}
                />
              </Tooltip>
            </div>
          }
        </div>
        <div className="internal-block" style={{justifyContent: "flex-end", alignItems: "center"}}>
          <div>
            <div style={{display: "flex", alignItems: "center"}}
              onClick={() => goToDetail(data?.id)}
            >
              <p className="change-text">
                <FormattedMessage id="preCog.accountingTab.change" /></p>
              <div className="arrow-container">
                <FontAwesomeIcon
                  icon={["far", "arrow-right"]}
                  style={{color: "#0090d1", cursor: "pointer"}}
                />
              </div>
            </div>
            { data?.doc?.source !== "B2B" &&
            <div style={{display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              marginTop: "10px"}}
            onClick={() => setOpenDeleteModal(true)}
            >
              <p  className="change-text">
                <FormattedMessage id="preCog.accountingTab.delete" /></p>
              <div className="arrow-container">
                <FontAwesomeIcon
                  icon={["far", "trash-alt"]}
                  style={{color: "#0090d1", cursor: "pointer"}}
                />
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      <DeleteModal
        visible={openDeleteModal}
        onClose={() => {
          setOpenDeleteModal(false);
        }}
        onClick={() => {
          setOpenDeleteModal(false);
        }}
        spinnerDelete={spinnerDelete}
        setSpinnerDelete={setSpinnerDelete}
        setOpenDeleteModal={setOpenDeleteModal}
        data={data}
        index={index}
        selectedDocuments={selectedDocuments}
        setSelectedDocuments={setSelectedDocuments}
        allDocumentsSelected={allDocumentsSelected}
        setAllDocumentsSelected={setAllDocumentsSelected}
        navigateTo={null}
      />
    </div>
  );
};

export default AccountBlock;
